import { Controller } from "stimulus";

// Loads a tab/filter switch over AJAX and swaps only the content target in
// place. The tab bar stays in the DOM; we just move the active state. Each
// index already responds to xhr requests with its table partial, so no special
// header is needed. Links that should trigger this are marked `js-tab-remote`.
export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.onClick = this.onClick.bind(this);
    this.element.addEventListener("click", this.onClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick);
  }

  onClick(event) {
    const link = event.target.closest("a.js-tab-remote");

    if (!link || !this.element.contains(link)) return;

    event.preventDefault();
    this.setActive(link);
    this.loadContent(link.getAttribute("href"));
  }

  setActive(link) {
    // For a dropdown-style tab the visible "tab" is the toggle button, so move
    // the label to the clicked item, then activate the toggle.
    let activeTab = link;
    const dropdownMenu = link.closest(".dropdown-menu");

    if (dropdownMenu) {
      activeTab = dropdownMenu.parentElement.querySelector(".nav-link");

      const label = activeTab && activeTab.querySelector(".js-tab-remote-label");
      if (label) label.textContent = link.textContent.trim();
    }

    const navTabs = this.element.querySelector(".nav-tabs");
    if (navTabs && activeTab) {
      navTabs.querySelectorAll(".nav-link").forEach((tab) => tab.classList.remove("active"));
      activeTab.classList.add("active");
    }
  }

  loadContent(url) {
    this.setSpinner();

    $.ajax({
      url: url,
      type: "GET",
      dataType: "html",
      beforeSend: (xhr) => {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: (response) => {
        this.contentTarget.innerHTML = response;

        $('[data-toggle="tooltip"]').tooltip();
      },
      error: () => {
        window.notyf.error("Something went wrong when loading your request. Please refresh the page or try again.");
      },
    });
  }

  setSpinner() {
    this.contentTarget.innerHTML = '<h3 class="text-center p-5"><i class="fad fa-spinner-third fa-spin d-inline-block text-secondary fa-2x"></i></h3>';
  }
}
